// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-M":"M_vanlife-roadtrips-M__7U99h"};